import React from 'react';

export interface IMaintenanceTimerItem {
    serviceItem: string;
    dueIn: string;
}

export interface IMaintenanceTimers {
    system: IMaintenanceTimerItem[];
    units: {
        unitNumber: number;
        items: IMaintenanceTimerItem[];
    }[];
}

interface MaintenanceTimerCardProps {
    maintenanceTimers: IMaintenanceTimers;
}

const MaintenanceTimerCard: React.FC<MaintenanceTimerCardProps> = ({
    maintenanceTimers
}) => {
    const renderMaintenanceItems = (items: IMaintenanceTimerItem[]) => {
        if (!items || !Array.isArray(items) || items.length === 0) {
            return null;
        }
        return items.map((item, index) => (
            <div key={index} className="maintenance-timer-table-row">
                <div className="maintenance-timer-service-item">
                    {item.serviceItem}
                </div>
                <div>{item.dueIn}</div>
            </div>
        ));
    };

    if (
        !maintenanceTimers ||
        !Array.isArray(maintenanceTimers.system) ||
        !Array.isArray(maintenanceTimers.units) ||
        (maintenanceTimers.system.length === 0 &&
            maintenanceTimers.units.length === 0)
    ) {
        return null;
    }

    return (
        <div className="maintenance-timers-card">
            <div className="maintenance-timers-card-header">
                <h3>Maintenance Timers</h3>
            </div>
            <div className="maintenance-timers-card-grid">
                {maintenanceTimers.system.length > 0 && (
                    <div className="maintenance-timer-item-card">
                        <div className="maintenance-timer-item-card-header">
                            System
                        </div>
                        <div className="maintenance-timer-table">
                            <div className="maintenance-timer-table-header">
                                <div>Service Item</div>
                                <div>Due In</div>
                            </div>
                            {renderMaintenanceItems(maintenanceTimers.system)}
                        </div>
                    </div>
                )}
                {maintenanceTimers.units
                    .filter(
                        unit =>
                            unit &&
                            Array.isArray(unit.items) &&
                            unit.items.length > 0
                    )
                    .map((unit, unitIndex) => (
                        <div
                            key={unitIndex}
                            className="maintenance-timer-item-card"
                        >
                            <div className="maintenance-timer-item-card-header">
                                Unit {unit.unitNumber}
                            </div>
                            <div className="maintenance-timer-table">
                                <div className="maintenance-timer-table-header">
                                    <div>Service Item</div>
                                    <div>Due In</div>
                                </div>
                                {renderMaintenanceItems(unit.items)}
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default MaintenanceTimerCard;
